<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-main class="flex-column">
      <div class="flex justify-center" v-if="status == 2 "><span class="bg-82b925-20-ff p-absolute" style="margin: 0 auto">客户预算已结算存档</span></div>
      <div class="flex justify-center" v-else-if="status == 1"><span class="bg-00-20-ff p-absolute" style="margin: 0 auto">客户预算已锁定</span></div>
      <div class="customerInfo flex align-center justify-space-between">
        <div class="bg-f3f4f7 plr-20" style="height: 50px">
          <button class="btn-30-border-30313a-small mt-10 text-left" @click="backPage"><i class="el-icon-back mr-10"></i>返回房间列表</button>
        </div>
        <div class="title w-0 bg-ff flex-1 flex align-center plr-10">
          <el-tabs v-model="budgetRoomId " type="card" class="w-100" @tab-click="switchTab">
            <el-tab-pane v-for="(item, index) in tab" :key="index" :label="item.name" :name="item.id.toString()" ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7 h-0">
        <div class="ptb-8 plr-10 top flex align-center mb-10">
          <!--<el-button-->
            <!--class="btn-30-bg-82b925-big"-->
            <!--@click="sumSave"-->
            <!--v-if="!define && permission.includes('basic')"-->
            <!--v-loading.fullscreen.lock="fullscreenLoading">-->
            <!--汇总保存-->
          <!--</el-button>-->
          <button class="btn-30-bg-82b925-big" @click="sumSave" v-if="!define && permission.includes('basic')">汇总保存</button>
          <div class="line"></div>
          <div class="plr-20 text-left">
            <div class="font-12-30313a">预算金额：</div>
            <div class="font-18-30313a">¥{{room.budgetAmount ? room.budgetAmount : '0'}}</div>
          </div>
          <div class="line"></div>
          <div class="plr-20 text-left">
            <div class="font-12-30313a">增减金额：</div>
            <div class="font-18-30313a">¥{{room.increaseDecreaseAmount ? room.increaseDecreaseAmount : '0'}}</div>
          </div>
          <div class="line"></div>
          <div class="plr-20 text-left">
            <div class="font-12-30313a">结算金额：</div>
            <div class="font-18-82b925">¥{{room.settlementAmount ? room.settlementAmount : '0'}}</div>
          </div>
          <div class="line"></div>
          <div class="plr-20 text-left">
            <div class="font-12-30313a">备注：</div>
            <div class="font-18-30313a">{{room.remark ? room.remark : '-'}}</div>
          </div>
        </div>
         <div class="flex mb-10" v-if="define">
          <div class="flex" v-if="!lookMaterialy">
            <div class=" flex align-center mr-5 button" :class="status == 2 ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="onAddQuantity">
              <img :src="status == 2 ? '/static/images/add-hui.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
              新增定额
            </div>
            <div class="flex align-center mr-5 button" :class="status == 2 ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="onAddMaterialy">
              <img :src="status == 2 ? '/static/images/add-hui.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
              新增材料
            </div>
            <div class="flex align-center mr-5 button" :class="status == 2 ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="onAddCost" v-if="define">
              <img :src="status == 2 ? '/static/images/add-hui.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
              新增费用
            </div>
            <div class="flex align-center mr-5 button" :class="status == 2 ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="onCopyProject">
              <img :src="status == 2 ? '/static/images/fuzhi-hui.png' : '/static/images/fuzhi.png'" class="icon-14 mr-5" alt="">
              复制项目
            </div>
            <div class="flex align-center mr-5 button" :class="status == 2 ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="deleteProject">
              <img :src="status == 2 ? '/static/images/shanchu1-hui.png' : '/static/images/shanchu1.png'" class="icon-14 mr-5" alt="">
              删除项目
            </div>
          </div>
          <div class="flex" v-if="!define">
            <div class="line-small"></div>
            <div class="flex align-center cursor" @click="selectIsMaterial">
              <img class="mr-5" :src="lookMaterialy ? '/static/images/customer/xuanzhong.png' : '/static/images/customer/weixuan.png'" alt="">
              <div class="font-12-ff5555">2只看材料{{define}}</div>
            </div>
          </div>
        </div>
        <div class="flex mb-10" v-else>
          <div class="flex" v-if="permission.includes('basic')">
            <div class="flex" v-if="!lookMaterialy && changeLockStatus == 0">
              <div class=" flex align-center mr-5 button" :class="status == 2 && !this.permission.includes('checkComputation') ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="onAddQuantity">
                <img :src="status == 2  && !this.permission.includes('checkComputation') ? '/static/images/add-hui.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
                新增定额
              </div>
              <div class="flex align-center mr-5 button" :class="status == 2  && !this.permission.includes('checkComputation') ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="onAddMaterialy">
                <img :src="status == 2 && !this.permission.includes('checkComputation') ? '/static/images/add-hui.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
                新增材料
              </div>
              <div class="flex align-center mr-5 button" :class="status == 2 ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="onAddCost" v-if="define">
                <img :src="status == 2 ? '/static/images/add-hui.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
                新增费用
              </div>
              <div class="flex align-center mr-5 button" :class="status == 2 ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="onCopyProject">
                <img :src="status == 2 ? '/static/images/fuzhi-hui.png' : '/static/images/fuzhi.png'" class="icon-14 mr-5" alt="">
                复制项目
              </div>
              <div class="flex align-center mr-5 button" :class="status == 2 ? 'btn-24-border-e2-ffffff' : 'btn-24-bg-ff'" @click="deleteProject">
                <img :src="status == 2 ? '/static/images/shanchu1-hui.png' : '/static/images/shanchu1.png'" class="icon-14 mr-5" alt="">
                删除项目
              </div>
            </div>
            <div class="flex" v-if="!define">
              <div class="line-small"></div>
              <div class="flex align-center cursor" @click="selectIsMaterial">
                <img class="mr-5" :src="lookMaterialy ? '/static/images/customer/xuanzhong.png' : '/static/images/customer/weixuan.png'" alt="">
                <div class="font-12-ff5555">只看材料</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1 flex-column h-0">
          <div class="mb-10 flex-1 h-0 budgetContent">
            <erp-table ref="erpTable" @on-discount="onDiscount" @on-adjusted="onAdjusted" @on-modified="onModified" @on-deleted="onDeleted" @on-expense="onExpense" @on-check="onCheck" :is-edit="true" btn-show-key="status" :editable-status="editableStatus" :customs="customs" @on-change="onChange" @on-replace="onReplace" :table-data="tableDataBudget" @change-current-row="changeCurrentRow" :loading="loading" :column-data="columnData" @on-modify="onModifyRow" modify-method="on-modify" @select-change="selectChange"></erp-table>
          </div>
          <move-vertical :max="560" :min="100" class="mtb-15" moveDom="bottom"></move-vertical>
          <div id="moveTop" class="pt-15 flex-column" style="height: 220px" >
            <div class="flex align-center">
              <div class="flex align-center mr-20 cursor pb-5 relative" :class="{'tabActive': index == smallTabIndex}" v-for="(item, index) in currentRowType == 3 ? smallTab1 : smallTab" :key="index" @click="switchSmallTab(index)">
                <div class="mr-5" :class="index == smallTabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
                <div class="font-bold" :class="index == smallTabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{item}}</div>
              </div>
            </div>
            <div class="hr mb-20" style="margin-top: -1px;"></div>
            <div class="overflow-y flex-1">
              <div class="text-left font-12-30313a h-100" v-if="smallTabIndex == 0 && currentRowType !== 1">
                <el-input v-if="define== 1" type="textarea"  :rows="5" v-model="materialDescription" @blur="onModifyMaterial(materialDescription)"></el-input>
                <div v-else>{{materialDescription}}</div>
              </div>
              <div class="text-left flex h-100" v-if="smallTabIndex == 1 && currentRowType !== 1">
                <div v-for="(item, index) in materialPhotoList" :key="index" class="mr-10">
                  <el-image style="width: 90px; height: 90px" :src="item.completePath" fit="cover"></el-image>
                  <div class="font-12-30313a text-center">{{item.name}}</div>
                </div>
              </div>
              <div class="text-left flex h-100" v-if="smallTabIndex == 2 && currentRowType == 3">
                <div class="flex-column align-start flex-1 w-100">
                  <div class="btn-24-bg-ff flex align-center mb-10 button" @click="addQuota">
                    <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
                    添加定额
                  </div>
                  <div class="flex-1 h-0" style="width: 99.9%;">
                    <erp-table class="grayTable" ref="erpTable2" :table-data="quotaQuantities" :loading="loading" :column-data="columnData2"></erp-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-dialog title="变更量明细" :visible.sync="changeDialog" width="85%" class="handlePlan">
      <div class="plr-20 ptb-10">
        <div class="flex" v-if="status !== 2  || this.permission.includes('checkComputation')">
          <div class="flex align-center mr-5 mb-5 btn-24-bd-30313a" @click="addchange" v-if="permission.length > 0 && changeLockStatus == 0">
            <img src="/static/images/add.png" class="icon-14 mr-5" alt="">
            <div>添加</div>
          </div>
        </div>
        <div style="min-height: 360px">
          <erp-table :table-data="tableChange"  :column-data="columnChange"></erp-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="添加变更详情" :visible.sync="modelDetailShow" @closed="onCloseDetail">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">项目名称：</div>
          <div class="font-12-b9b9b9">{{changeRow.name}}</div>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">结算量：</div>
          <el-input v-model="settlement" type="number" class="flex-1" placeholder="请输入结算量"></el-input>
        </div>
        <div class="flex mb-10">
          <div class="font-12-30313a mr-5">备注：</div>
          <el-input type="textarea" v-model="remark" :row="3" class="flex-1" placeholder="请输入备注"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseDetail">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="onSubmitDetail">确定</div>
      </div>
    </el-dialog>
    <change-amount></change-amount>
    <add-quantity ref="addQuantity" @set-quota="setQuota" :budgetContentId="budgetContentId" :budgetId="budgetId" :budgetRoomId="budgetRoomId" :budgetContentList="budgetContentList" :define="define" :replaceId="replaceId" :isGive="isGive"></add-quantity>
    <add-materialy ref="addMaterialy" :budgetType="budgetType" :budgetId="budgetId" :budgetRoomId="budgetRoomId" @choose-material="onSubmitQuantity" @add-material="addMaterial" :define="define" :replaceId="replaceId" :isGive="isGive" :status="status"></add-materialy>
    <copy-project ref="copyProject" @copy-project="onSubmitProject" :tab="tab" :budgetRoomId="budgetRoomId"></copy-project>
  </el-container>
</template>

<script>
import MoveVertical from '../../components/MoveVertical'
import ErpTable from '../../components/ErpTable'
import ChangeAmount from './enterRoomItem/changeAmount'
import AddMaterialy from './enterRoomItem/AddMaterialy'
import AddQuantity from './enterRoomItem/AddQuantity'
import CopyProject from './enterRoomItem/CopyProject'
export default {
  name: 'enterRoom',
  components: {MoveVertical, ErpTable, ChangeAmount, AddMaterialy, AddQuantity, CopyProject},
  data () {
    return {
      room: {},
      isGive: null,
      define: null,
      status: null,
      budgetGroup: {},
      budgetId: null,
      budgetRoomId: null,
      budgetContentId: null,
      budgetContentList: {},
      budgetType: 1,
      tab: [],
      smallTab: ['材料及工艺说明', '材料图片'],
      smallTab1: ['工艺说明', '相关图片', '定额用量'],
      smallTabIndex: 0,
      loading: false,
      isColVisible: false,
      columnData: [{
        type: 'selection',
        width: '40'
      }, {
        field: 'TypeBudget',
        title: '预算类型',
        width: '80'
      }, {
        field: 'sort',
        title: '序号',
        width: '60',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'noSummaryFlag',
        title: '不计算',
        width: '60',
        isDefine: true,
        child: [{
          title: '是',
          key: 'noSummaryFlag',
          methodName: 'on-discount',
          type: 'switch',
          activeValue: 1,
          inactiveValue: 0
        }]
      }, {
        field: 'isAdjusted',
        title: '允许调整',
        width: '70',
        isDefine: true,
        child: [{
          title: '是',
          key: 'isAdjusted',
          methodName: 'on-adjusted',
          type: 'radio',
          activeValue: 1,
          inactiveValue: -1
        }]
      }, {
        field: 'isModified',
        title: '允许修改',
        width: '70',
        isDefine: true,
        child: [{
          title: '是',
          key: 'isModified',
          methodName: 'on-modified',
          type: 'radio',
          activeValue: 1,
          inactiveValue: -1
        }]
      }, {
        field: 'isDeleted',
        title: '不允许删除',
        width: '100',
        isDefine: true,
        child: [{
          title: '是',
          key: 'isDeleted',
          methodName: 'on-deleted',
          type: 'radio',
          activeValue: 1,
          inactiveValue: -1
        }]
      }, {
        field: 'expenseItem',
        title: '费用项目',
        width: '70',
        isDefine: true,
        child: [{
          title: '是',
          key: 'expenseItem',
          methodName: 'on-expense',
          type: 'radio',
          activeValue: 1,
          inactiveValue: -1
        }]
      }, {
        field: 'operate',
        title: '操作',
        width: '120',
        isDefine: true,
        child: [{
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
          title: '变更量',
          methodName: 'on-change',
          showStatus: 1
        }, {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
          title: '替换',
          methodName: 'on-replace',
          showStatus: 2
        }, {
          type: 'btn',
          className: 'font-12-30313a',
          title: '不可替换',
          showStatus: 3
        }]
      }, {
        field: 'specialItem',
        title: '特项',
        width: '70',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'specialContent',
        title: '非项目经理',
        width: '100',
        isDefine: true,
        child: [{
          title: '是',
          key: 'specialContent',
          methodName: 'on-check',
          type: 'switch',
          activeValue: 1,
          inactiveValue: -1
        }]
      }, {
        field: 'name',
        title: '项目名称',
        minWidth: '360',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'subitem',
        title: '项目备注',
        minWidth: '200',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'unit',
        title: '单位',
        width: '60',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'priceType',
        title: '价格类型',
        width: '80',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'budgetFormula',
        title: '预算量公式',
        width: '180',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'budgetNumber',
        title: '预算量',
        width: '80',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'clientPrice',
        title: '客户单价',
        width: '100',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'budgetClientSum',
        title: '预算合价',
        width: '100',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'increaseDecrease',
        title: '增减量',
        width: '80',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'settlementNumber',
        title: '结算量',
        width: '80',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'checkNumber',
        title: '核算量',
        width: '80',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'settlementClientSum',
        title: '结算合价',
        width: '100',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'costPrice',
        title: '成本单价',
        width: '100',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'budgetCostSum',
        title: '预算成本合价',
        width: '100',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'settlementCostSum',
        title: '结算成本合价',
        width: '100',
        editRender: {
          name: 'input'
        }
      }],
      tableDataBudget: [],
      tableData: [],
      quotaQuantities: [],
      columnData2: [{
        field: 'type',
        title: '人材机',
        width: '120',
        formatter: 'toQuotaType',
        editType: 'select',
        editRender: {
          name: 'select',
          options: [
            {
              value: 1,
              label: '人工'
            },
            {
              value: 2,
              label: '辅料'
            },
            {
              value: 3,
              label: '机械'
            },
            {
              value: 4,
              label: '其他'
            }
          ]
        }
      }, {
        field: 'specialItem',
        title: '特项',
        width: '55'
      }, {
        field: 'name',
        title: '材料名称',
        width: '100'
      }, {
        field: 'unit',
        title: '单位',
        width: '200'
      }, {
        field: 'quantity',
        title: '数量',
        width: '200'
      }, {
        field: 'clientPrice',
        title: '客户单价',
        width: '200'
      }, {
        field: 'customerPrice',
        title: '客户合价',
        minWidth: '100'
      }],
      lookMaterialy: false, // 只看材料选择
      currentRow: {},
      customs: [
        {
          field: 'sort',
          visible: false
        },
        {
          field: 'isAdjusted',
          visible: false
        },
        {
          field: 'isDeleted',
          visible: false
        },
        {
          field: 'isModified',
          visible: false
        },
        {
          field: 'expenseItem',
          visible: false
        },
        {
          field: 'operate',
          visible: false
        },
        {
          field: 'budgetNumber',
          visible: false
        }, {
          field: 'checkNumber',
          visible: false
        }, {
          field: 'clientPrice',
          visible: false
        }, {
          field: 'budgetClientSum',
          visible: false
        }, {
          field: 'increaseDecrease',
          visible: false
        }, {
          field: 'settlementNumber',
          visible: false
        }, {
          field: 'settlementClientSum',
          visible: false
        }, {
          field: 'costPrice',
          visible: false
        }, {
          field: 'budgetCostSum',
          visible: false
        }, {
          field: 'settlementCostSum',
          visible: false
        }
      ],
      editableStatus: true,
      projectIds: '',
      currentRowType: 2,
      materialPhotoList: [],
      materialDescription: '',
      changeDialog: false,
      modelDetailShow: false,
      tableChange: [],
      columnChange: [ // 变更
        {
          field: 'createTime',
          title: '变更日期',
          width: '200',
          editType: 'date',
          dateConfig: {
            format: 'yyyy-MM-dd HH:mm:ss',
            type: 'date',
            valueFormat: 'timestamp'
          },
          editRender: {
            name: 'input'
          },
          formatter: ['toDateString', 'yyyy-MM-dd HH:mm:ss']
        }, {
          field: 'name',
          title: '项目名称',
          width: '280'
        }, {
          field: 'modifierName',
          title: '操作人',
          width: '100'
        }, {
          field: 'settlement',
          title: '结算量',
          width: '60'
        }, {
          field: 'remark',
          title: '备注',
          width: ''
        }
      ],
      changeRow: {},
      settlement: '',
      remark: '',
      replaceId: '',
      permission: [],
      selectList: []
    }
  },
  watch: {
    budgetRoomId (newVal) {
      if (newVal) {
        this.budgetRoomId = newVal
      }
    },
    budgetId (newVal) {
      if (newVal) {
        this.budgetId = newVal
      }
    },
    define (newVal) {
      if (newVal) {
        this.define = parseInt(newVal)
      }
    },
    status (newVal) {
      if (newVal) {
        this.status = parseInt(newVal)
      }
    }
  },
  created () {
    console.log(this.$route.query.define)
    this.define = parseInt(this.$route.query.define) // define 1报价模板 2房间包
    this.budgetRoomId = this.$route.query.budgetRoomId
    this.status = parseInt(this.$route.query.status)
    this.budgetId = this.$route.query.budgetId
    this.changeLockStatus = this.$route.query.changeLockStatus
    if (this.define) {
      this.editableStatus = false
    }
    this.getPermission()
    this.aboutRoom()
    this.budgetRoom()
    this.budgetContent()
  },
  mounted () {
  },
  methods: {
    addMaterial (data, priceList, rebateFlag) {
      var reg = new RegExp('null', 'g')
      // let arr = this.$refs.erpTable.getSelectEvent()
      // let arr = this.selectList
      let targetId = ''
      let isLast = ''
      if (this.selectList.length > 0) {
        targetId = this.selectList[0].id
        isLast = null
      } else if (this.tableDataBudget.length > 0) {
        targetId = this.tableDataBudget[this.tableDataBudget.length - 1].id
        isLast = 1
      } else {
        targetId = -1
        isLast = null
      }
      let params = {
        type: 2,
        targetId: targetId,
        budgetRoomId: this.budgetRoomId,
        materialId: data.id,
        priceId: priceList.id,
        priceType: priceList.name,
        unit: data.salesUnit,
        ...data,
        standard: data.standard + ' ' + data.model,
        costPrice: data[priceList.costPriceField],
        name: (data.brand + ' ' + data.name + ' ' + data.standard + ' ' + data.model).replace(reg, ''),
        rebateFlag: rebateFlag
      }
      params.isLast = isLast
      if (this.status === 1) {
        params.isConfirm = 2
        params.calculationSort = 1
      }
      if (this.isGive === 1) {
        params.clientPrice = 0
      } else {
        params.clientPrice = data[priceList.customerPriceField] === -1 ? 0 : data[priceList.customerPriceField]
      }
      if (this.replaceId) {
        params.id = this.replaceId
        let port = ''
        if (this.define === 2) {
          params.companyId = this.$store.state.companyId
          port = 'budgetContentPackage/modify'
          this.axios.post(port, params).then(res => {
            if (res.data.success) {
              this.addMaterialyVisible = false
              this.budgetRoom()
              this.budgetContent()
              this.$message({
                message: '替换材料成功',
                type: 'success',
                duration: 1000,
                offset: 400
              })
            }
          })
        } else if (this.define === 1) {
          params.budgetId = this.budgetId
          port = 'budgetContentTemplate/modify'
          this.axios.post(port, params).then(res => {
            if (res.data.success) {
              this.addMaterialyVisible = false
              this.budgetRoom()
              this.budgetContent()
              this.$message({
                message: '替换材料成功',
                type: 'success',
                duration: 1000,
                offset: 400
              })
            }
          })
        } else {
          params.budgetId = this.budgetId
          port = 'budgetContent/modify'
          if (!data.businessId) {
            this.$message({
              message: '此材料没有供应商找材料部协调后重试',
              type: 'warning',
              duration: 1000,
              offset: 200
            })
          } else {
            this.axios.post(port, params).then(res => {
              if (res.data.success) {
                this.addMaterialyVisible = false
                this.budgetRoom()
                this.budgetContent()
                this.$message({
                  message: '替换材料成功',
                  type: 'success',
                  duration: 1000,
                  offset: 400
                })
              }
            })
          }
        }
      } else {
        let port = ''
        if (this.define === 2) {
          params.companyId = this.$store.state.companyId
          port = 'budgetContentPackage/save'
          this.axios.post(port, params).then(res => {
            if (res.data.success) {
              // let position = -1
              // if (arr.length > 0) {
              //   position = arr[0]
              // }
              // this.$refs.erpTable.insertAt(res.data.data, position)
              this.budgetRoom()
              this.budgetContent()
              // arr = []
              targetId = ''
              isLast = null
              this.$message({
                message: '新增材料成功',
                type: 'success',
                duration: 1000,
                offset: 400
              })
            }
          })
        } else if (this.define === 1) {
          params.budgetId = this.budgetId
          port = 'budgetContentTemplate/save'
          this.axios.post(port, params).then(res => {
            if (res.data.success) {
              // let position = -1
              // if (arr.length > 0) {
              //   position = arr[0]
              // }
              // this.$refs.erpTable.insertAt(res.data.data, position)
              this.budgetRoom()
              this.budgetContent()
              // arr = []
              targetId = ''
              isLast = null
              this.$message({
                message: '新增材料成功',
                type: 'success',
                duration: 1000,
                offset: 400
              })
            }
          })
        } else {
          params.budgetId = this.budgetId
          port = 'budgetContent/save'
          if (!data.businessId) {
            this.$message({
              message: '此材料没有供应商找材料部协调后重试',
              type: 'warning',
              duration: 1000,
              offset: 200
            })
          } else {
            this.axios.post(port, params).then(res => {
              if (res.data.success) {
                // let position = -1
                // if (arr.length > 0) {
                //   position = arr[0]
                // }
                // this.$refs.erpTable.insertAt(res.data.data, position)
                this.budgetRoom()
                this.budgetContent()
                // arr = []
                targetId = ''
                isLast = null
                this.$message({
                  message: '新增材料成功',
                  type: 'success',
                  duration: 1000,
                  offset: 400
                })
              }
            })
          }
        }
      }
    },
    setQuota (row) {
      // let arr = this.$refs.erpTable.getSelectEvent()
      // let arr = this.selectList
      let targetId = ''
      let isLast = null
      if (this.selectList.length > 0) {
        targetId = this.selectList[0].id
        isLast = null
      } else if (this.tableDataBudget.length > 0) {
        targetId = this.tableDataBudget[this.tableDataBudget.length - 1].id
        isLast = 1
      } else {
        targetId = -1
        isLast = null
      }
      let params = {
        type: 3,
        targetId: targetId,
        budgetRoomId: this.budgetRoomId,
        quotaId: row.id,
        description: row.workmanship,
        ...row,
        clientPrice: row.customerPrice
      }
      params.isLast = isLast
      if (this.isGive === 1) {
        params.clientPrice = 0
      } else {
        params.clientPrice = row.customerPrice === -1 ? 0 : row.customerPrice
      }
      if (this.replaceId) {
        params.id = this.replaceId
        let port = ''
        if (this.define === 2) {
          params.companyId = this.$store.state.companyId
          port = 'budgetContentPackage/modify'
        } else if (this.define === 1) {
          params.budgetId = this.budgetId
          port = 'budgetContentTemplate/modify'
        } else {
          params.budgetId = this.budgetId
          port = 'budgetContent/modify'
        }
        this.axios.post(port, params).then(res => {
          if (res.data.success) {
            this.addQuantityVisible = false
            this.budgetRoom()
            this.budgetContent()
            this.$message({
              message: '替换定额成功',
              type: 'success',
              duration: 1000,
              offset: 400
            })
          }
        })
      } else {
        let port = ''
        if (this.status === 1) {
          params.calculationSort = 1
        }
        if (this.define === 2) {
          params.companyId = this.$store.state.companyId
          port = 'budgetContentPackage/save'
        } else if (this.define === 1) {
          params.budgetId = this.budgetId
          port = 'budgetContentTemplate/save'
        } else {
          params.budgetId = this.budgetId
          port = 'budgetContent/save'
        }
        this.axios.post(port, params).then(res => {
          if (res.data.success) {
            // let position = -1
            // if (arr.length > 0) {
            //   position = arr[0]
            // }
            // this.$refs.erpTable.insertAt(res.data.data, position)
            this.budgetContent()
            // arr = []
            targetId = ''
            isLast = null
            this.$message({
              message: '新增定额成功',
              type: 'success',
              duration: 1000,
              offset: 400
            })
          }
        })
      }
    },
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'budget',
        parentGroup: 'budget'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
          this.contrlTable()
        }
      })
    },
    onChange (row) {
      this.changeRow = row
      this.changeDialog = true
      this.changeList()
    },
    onReplace (row) { // 替换
      this.replaceId = row.id
      if (parseInt(row.type) === 2) {
        this.$refs.addMaterialy.addMaterialyVisible = true
      } else if (parseInt(row.type) === 3) {
        this.$refs.addQuantity.addQuantityVisible = true
      }
    },
    sumSave () { // 汇总保存
      let params = {
        id: this.budgetId
      }
      let port = ''
      if (this.define) {
        port = 'budgetTemplate/summary'
      } else {
        port = 'budget/summary'
      }
      this.axios.post(port, params).then(res => {
        if (res.data.success) {
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
            offset: 100
          })
          this.budgetContent()
          this.aboutRoom()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            duration: 1000,
            offset: 100
          })
        }
      })
    },
    aboutRoom () {
      let params = {
        id: this.budgetRoomId
      }
      this.axios.post('budgetRoom/getById', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          this.room = res.data.data
          this.isGive = res.data.data.isGive
        }
      })
    },
    selectChange () {
      this.selectList = this.$refs.erpTable.getSelectEvent()
    },
    budgetRoom () { // 房间列表
      if (this.define === 2) { // 房间包列表
        let params = {
          companyId: this.$store.state.companyId
        }
        this.axios.post('budgetRoomPackage/list', params).then(res => {
          if (res.data.success) {
            this.tab = res.data.data
          }
        })
      } else if (this.budgetId) {
        let params = {
          budgetId: this.budgetId
        }
        let port = ''
        if (this.define === 1) {
          port = 'budgetRoomTemplate/list'
        } else {
          port = 'budgetRoom/list'
        }
        this.axios.post(port, params).then(res => {
          if (res.data.success) {
            this.tab = res.data.data
          }
        })
      }
    },
    budgetContent () { // 子项内容
      if (this.budgetRoomId) {
        let params = {
          budgetRoomId: this.budgetRoomId
        }
        if (this.lookMaterialy) {
          params.type = 2
        }
        let port = ''
        if (this.define === 2) {
          port = 'budgetContentPackage/list'
        } else if (this.define === 1) {
          port = 'budgetContentTemplate/list'
        } else {
          port = 'budgetContent/list'
        }
        this.axios.post(port, params).then(res => {
          if (res.data.success) {
            let list = res.data.data
            for (let i = 0; i < list.length; i++) {
              if (list[i].specialContent !== 1) {
                list[i].specialContent = -1
              }
            }
            list.forEach(item => {
              if (parseInt(item.type) === 2) {
                item.TypeBudget = '材料'
              } else if (parseInt(item.type) === 3) {
                item.TypeBudget = '定额'
              } else {
                item.TypeBudget = '项目'
              }
              if (this.define) {
                if (parseInt(item.type) === 2 || parseInt(item.type) === 3) {
                  item.status = 2
                } else {
                  item.status = 3
                }
              } else {
                item.status = 1
              }
              if (!this.define) {
                if (this.status === 1) {
                  var reg = new RegExp('budgetFormula', '')
                  item.unEditable = item.unEditable.replace(reg, '')
                }
                if (this.status === 2) {
                  item.unEditable = ''
                } else if (this.permission.includes('checkComputation')) {
                  item.unEditable = item.unEditable + ',' + 'checkNumber'
                } else {
                  item.unEditable = item.unEditable.replace('checkNumber', '')
                }
              }
            })
            this.tableDataBudget = list
          }
        })
        params = {}
      }
    },
    changeCurrentRow (row) {
      this.currentRow = row
      if (parseInt(row.type) === 2) {
        this.currentRowType = 2
        this.getMaterial(row.materialId)
        this.materialDescription = row.description
        // this.materialEditDes(row.materialId)
      } else if (parseInt(row.type) === 3) {
        this.currentRowType = 3
        this.getQuota(row.quotaId)
        this.getQuotaQuantities()
        this.materialDescription = row.description
      } else {
        this.currentRowType = 0
        this.materialDescription = row.description
        this.materialPhotoList = []
      }
    },
    getMaterial (id) { // 材料相关
      let params = {
        id: id
      }
      this.axios.post('material/getById', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          if (res.data.data) {
            // this.materialDescription = res.data.data.description
            this.materialPhotoList = res.data.data.materialPhotoList
          }
        }
      })
    },
    getQuota (id) { // 定额相关
      let params = {
        id: id
      }
      this.axios.post('quota/getById', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          if (res.data.data) {
            // this.materialDescription = res.data.data.workmanship
            this.materialPhotoList = res.data.data.quotaPhotoList
          }
        }
      })
    },
    selectIsMaterial () { //  是否看材料
      this.lookMaterialy = !this.lookMaterialy
      this.contrlTable()
      this.budgetContent()
    },
    contrlTable () {
      let customs = [].concat(this.customs)
      this.customs = []
      for (var i = 0; i < customs.length; i++) {
        if (this.define === 1) {
          if (customs[i].field !== 'increaseDecrease' && customs[i].field !== 'settlementNumber' && customs[i].field !== 'budgetCostSum' && customs[i].field !== 'settlementCostSum') {
            customs[i].visible = true
          } else {
            customs[i].visible = false
          }
        } else if (this.define === 2) {
          if (customs[i].field !== 'TypeBudget' && customs[i].field !== 'budgetNumber' && customs[i].field !== 'checkNumber' && customs[i].field !== 'clientPrice' && customs[i].field !== 'budgetClientSum' && customs[i].field !== 'increaseDecrease' && customs[i].field !== 'settlementNumber' && customs[i].field !== 'settlementClientSum' && customs[i].field !== 'costPrice' && customs[i].field !== 'budgetCostSum' && customs[i].field !== 'settlementCostSum') {
            customs[i].visible = true
          } else {
            customs[i].visible = false
          }
        } else if (this.status === 1 || this.status === 2) { // status 1
          if (this.permission.includes('checkComputation')) {
            if (customs[i].field !== 'expenseItem' && customs[i].field !== 'isAdjusted' && customs[i].field !== 'isModified' && customs[i].field !== 'isDeleted') {
              customs[i].visible = true
            } else {
              customs[i].visible = false
            }
          } else {
            if (customs[i].field !== 'costPrice' && customs[i].field !== 'budgetCostSum' && customs[i].field !== 'settlementCostSum' && customs[i].field !== 'expenseItem' && customs[i].field !== 'isAdjusted' && customs[i].field !== 'isModified' && customs[i].field !== 'isDeleted') {
              customs[i].visible = true
            } else {
              customs[i].visible = false
            }
          }
        } else {
          if (this.permission.includes('checkComputation')) {
            if (customs[i].field !== 'operate' && customs[i].field !== 'increaseDecrease' && customs[i].field !== 'settlementNumber' && customs[i].field !== 'settlementClientSum' && customs[i].field !== 'settlementCostSum' && customs[i].field !== 'expenseItem' && customs[i].field !== 'isAdjusted' && customs[i].field !== 'isModified' && customs[i].field !== 'isDeleted') {
              customs[i].visible = true
            } else {
              customs[i].visible = false
            }
          } else {
            if (customs[i].field !== 'operate' && customs[i].field !== 'costPrice' && customs[i].field !== 'budgetCostSum' && customs[i].field !== 'increaseDecrease' && customs[i].field !== 'settlementNumber' && customs[i].field !== 'settlementClientSum' && customs[i].field !== 'settlementCostSum' && customs[i].field !== 'expenseItem' && customs[i].field !== 'isAdjusted' && customs[i].field !== 'isModified' && customs[i].field !== 'isDeleted') {
              customs[i].visible = true
            } else {
              customs[i].visible = false
            }
          }
        }
      }
      this.customs = this.customs.concat(customs)
    },
    switchTab (tab, event) {
      this.budgetRoomId = tab.name
      this.budgetContent()
      this.aboutRoom()
    },
    switchSmallTab (index) {
      this.smallTabIndex = index
    },
    onAddQuantity () { // 新增定量
      if (this.status !== 2 || this.permission.includes('checkComputation')) {
        this.$refs.addQuantity.addQuantityVisible = true
      }
    },
    onAddMaterialy () { // 新增材料
      if (this.status !== 2 || this.permission.includes('checkComputation')) {
        this.$refs.addMaterialy.addMaterialyVisible = true
      }
    },
    onAddCost () { // 新增费用
      let params = {
        type: 1,
        budgetRoomId: this.budgetRoomId,
        budgetContentId: this.budgetContentId
      }
      let port = ''
      if (this.define === 2) {
        port = 'budgetContentPackage/save'
      } else if (this.define === 1) {
        port = 'budgetContentTemplate/save'
      } else {
        port = 'budgetContent/save'
      }
      this.axios.post(port, params).then(res => {
        if (res.data.success) {
          this.budgetContent()
          this.$message({
            message: '新增费用成功',
            type: 'success',
            duration: 1000,
            offset: 100
          })
        }
      })
    },
    addQuota () { // 添加定量
      this.budgetType = 2
      this.$refs.addMaterialy.addMaterialyVisible = true
    },
    getQuotaQuantities () { // 定量列表
      let params = {
        budgetContentId: this.currentRow.id
      }
      this.axios.post('budgetQuantities/list', params).then(res => {
        if (res.data.success) {
          this.quotaQuantities = res.data.data
        }
      })
    },
    onSubmitQuantity (data, option) {
      let params = {
        name: data.name,
        budgetContentId: this.currentRow.id,
        budgetId: this.budgetId,
        materialId: data.id,
        type: 1,
        specialItem: data.specialItem,
        code: data.code,
        model: data.model,
        unit: data.salesUnit,
        quantity: 1,
        customerPrice: data[option.customerPriceField],
        costPrice: data[option.costPriceField]
      }
      this.axios.post('budgetQuantities/save', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: '添加用量成功',
            type: 'success',
            duration: 1000,
            offset: 400
          })
          this.getQuotaQuantities()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            duration: 1000,
            offset: 400
          })
        }
      })
    },
    onDiscount (row) {
      this.onModifyRow(row, true, 'noSummaryFlag')
    },
    onAdjusted (row) {
      this.onModifyRoom(row, true, 'isAdjusted')
    },
    onModified (row) {
      this.onModifyRoom(row, false, 'isModified')
    },
    onDeleted (row) {
      this.onModifyRoom(row, true, 'isDeleted')
    },
    onExpense (row) {
      this.onModifyRoom(row, true, 'expenseItem')
    },
    onCheck (row) {
      this.onModifyRoom(row, true, 'specialContent')
    },
    onModifyRow (row, cloumn, colName) {
      this.onModifyRoom(row, true, colName)
    },
    onModifyRoom (row, notRefresh, colName) { // 修改
      let params = {}
      let port = ''
      if (this.define === 1) {
        params = {
          id: row.id,
          [colName]: row[colName]
        }
        port = 'budgetContentTemplate/modify'
      } else if (this.define === 2) {
        params = {
          id: row.id,
          [colName]: row[colName]
        }
        port = 'budgetContentPackage/modify'
      } else {
        params = {
          id: row.id,
          [colName]: row[colName]
        }
        port = 'budgetContent/modify'
      }
      this.axios.post(port, params).then(res => {
        if (res.data.success) {
          // console.log(res.data.data.id)
          if (res.data.data.costPrice) {
            for (let i = 0; i < this.tableDataBudget.length; i++) {
              if (this.tableDataBudget[i].id === res.data.data.id) {
                this.tableDataBudget[i].costPrice = res.data.data.costPrice
              }
            }
          }
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
            offset: 100
          })
          // this.$erpTable.clearCheckboxRow()
          this.budgetContent()
          // if (!notRefresh) {
          //   this.budgetContent(false)
          // }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            duration: 1000,
            offset: 100
          })
        }
      })
    },
    onCopyProject () {
      if (this.status !== 2) {
        let customerArr = this.$refs.erpTable.getSelectEvent()
        if (customerArr.length === 0) {
          this.$message({
            message: `请先选择项目`,
            type: 'warning',
            duration: 1000,
            offset: 100
          })
        } else {
          this.$refs.copyProject.copyProjectVisible = true
          customerArr.forEach(item => {
            if (this.projectIds) {
              this.projectIds = this.projectIds + ',' + item.id
            } else {
              this.projectIds = item.id
            }
          })
        }
      }
    },
    onSubmitProject (data) {
      if (data.length > 0) {
        let roomIds = ''
        data.forEach(item => {
          if (roomIds) {
            roomIds = roomIds + ',' + item.id
          } else {
            roomIds = item.id
          }
        })
        let params = {
          ids: this.projectIds,
          roomIds: roomIds
        }
        let port = ''
        if (this.define === 2) {
          port = 'budgetContentPackage/copyContent'
        } else if (this.define === 1) {
          port = 'budgetContentTemplate/copyContent'
        } else {
          port = 'budgetContent/copyContent'
        }
        this.axios.post(port, params).then(res => {
          if (res.data.success) {
            this.$message({
              message: '复制项目成功',
              type: 'success',
              duration: 1000,
              offset: 100
            })
            this.projectIds = ''
            this.selectList = []
            this.budgetContent()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              duration: 1000,
              offset: 100
            })
          }
        })
      } else {
        this.$message.error('未选择房间')
      }
    },
    deleteProject () {
      if (this.status !== 2) {
        if (this.define) { // 报价模板、房间包
          let customerArr = this.$refs.erpTable.getSelectEvent()
          if (customerArr.length === 0) {
            this.$message({
              message: `请先选择项目`,
              type: 'warning',
              duration: 1000,
              offset: 100
            })
          } else {
            let ids = ''
            customerArr.forEach(item => {
              if (ids) {
                ids = ids + ',' + item.id
              } else {
                ids = item.id
              }
            })
            let port = ''
            if (this.define === 1) {
              port = 'budgetContentTemplate/deleteByIds'
            } else if (this.define === 2) {
              port = 'budgetContentPackage/deleteByIds'
            }
            let params = {
              ids: ids
            }
            this.axios.post(port, this.qs.stringify(params)).then(res => {
              if (res.data.success) {
                this.$message({
                  type: 'success',
                  message: '删除成功！',
                  duration: 1000,
                  offset: 100
                })
                this.budgetContent()
              }
            })
          }
        } else {
          if (this.status === 2) {
            this.$message({
              message: `预算已存档，不能删除`,
              type: 'warning',
              duration: 1000,
              offset: 100
            })
          } else {
            if (this.status === 1) {
              let customerArr = this.$refs.erpTable.getSelectEvent()
              if (customerArr.length === 0) {
                this.$message({
                  message: `请先选择项目`,
                  type: 'warning',
                  duration: 1000,
                  offset: 100
                })
              } else {
                let ids = ''
                customerArr.forEach(item => {
                  if (item.calculationSort === 1) {
                    if (ids) {
                      ids = ids + ',' + item.id
                    } else {
                      ids = item.id
                    }
                  }
                })
                let port = 'budgetContent/deleteByIds'
                if (ids) {
                  let params = {
                    ids: ids
                  }
                  this.axios.post(port, this.qs.stringify(params)).then(res => {
                    if (res.data.success) {
                      this.$message({
                        type: 'success',
                        message: '删除成功！',
                        duration: 1000,
                        offset: 100
                      })
                      this.selectList = []
                      this.budgetContent()
                    }
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: '不允许删除',
                    duration: 1000,
                    offset: 100
                  })
                }
              }
            } else {
              let customerArr = this.$refs.erpTable.getSelectEvent()
              if (customerArr.length === 0) {
                this.$message({
                  message: `请先选择项目`,
                  type: 'warning',
                  duration: 1000,
                  offset: 100
                })
              } else {
                let ids = ''
                customerArr.forEach(item => {
                  if (item.isDeleted !== 1) {
                    if (ids) {
                      ids = ids + ',' + item.id
                    } else {
                      ids = item.id
                    }
                  }
                })
                let port = 'budgetContent/deleteByIds'
                if (ids) {
                  let params = {
                    ids: ids
                  }
                  this.axios.post(port, this.qs.stringify(params)).then(res => {
                    if (res.data.success) {
                      this.$message({
                        type: 'success',
                        message: '删除成功！',
                        duration: 1000,
                        offset: 100
                      })
                      this.selectList = []
                      this.budgetContent()
                    }
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: '不允许删除',
                    duration: 1000,
                    offset: 100
                  })
                }
              }
            }
          }
        }
      }
    },
    addchange () {
      this.modelDetailShow = true
    },
    changeList () { // 变更
      let params = {
        contentId: this.changeRow.id
      }
      this.axios.post('budgetSettlement/list', params).then(res => {
        if (res.data.success) {
          this.tableChange = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            duration: 1000,
            offset: 100
          })
        }
      })
    },
    onSubmitDetail () { // 变更列表
      let params = {
        name: this.changeRow.name,
        contentId: this.changeRow.id,
        settlement: this.settlement,
        remark: this.remark
      }
      this.axios.post('budgetSettlement/save', params).then(res => {
        if (res.data.success) {
          this.$message.success('添加变更成功')
          this.changeList()
          this.modelDetailShow = false
          this.settlement = ''
          this.remark = ''
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            duration: 1000,
            offset: 100
          })
        }
      })
    },
    onCloseDetail () {
      this.settlement = ''
      this.remark = ''
      this.modelDetailShow = false
    },
    backPage () {
      this.$router.go(-1)
    },
    onClose () {
      this.$router.go(-1)
    },
    onModifyMaterial (description) {
      this.currentRow.description = description
      this.onModifyRow(this.currentRow, true, 'description')
    }
  }
}
</script>

<style lang="scss" scoped>
  /*.budgetContent /deep/ .vxe-table {*/
    /*color: #42b983 !important;*/
  /*}*/
  .overflow-y{
    overflow-y: auto;
  }
  .overflow{
    overflow: hidden;
  }
  .el-main{
    padding: 0;
  }
  .customerInfo{
    width: 100%;
    height: 50px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #30313a;
    text-align: left;
  }
  .close{
    width: 50px;
    height: 50px;
    background: #ff5555;
  }
  .customerInfo span{
    color: #b9b9b9;
  }
  .line{
    height: 32px;
    background: #f3f4f7;
    width: 1px;
    margin: 0 8px;
  }
  .line-small{
    height: 24px;
    background: #e2e2e2;
    width: 1px;
    margin: 0 8px;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
    margin: 10px 0;
  }
  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e2e2e2;
    margin: 12px 0;
  }
  .content{
    padding: 10px 20px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content .top{
    border-radius: 4px;
    background: #fff;
  }
  .tabActive:after{
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #46b8b0;
    position: absolute;
    bottom:0;
  }
  .title /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item{
    border: 0;
  }
  .title /deep/ .el-tabs--card>.el-tabs__header{
    border: 0;
  }
  .title /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav{
    border: 0;
    display: flex;
  }
  .title /deep/ .el-tabs__header{
    margin: 0;
  }
  .title /deep/ .el-tabs__nav-prev, .title /deep/ .el-tabs__nav-next{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #e2e2e2;
    background-color: #f3f4f7;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    top: 8px;
  }
  .title /deep/ .el-tabs__nav-prev i, .title /deep/ .el-tabs__nav-next i{
    font-weight: bold;
    font-size: 12px;
    color: #30313a;
  }
  .title /deep/ .el-tabs__nav-prev:hover, .title /deep/ .el-tabs__nav-next:hover{
    border-color: #46b8b0;
    background: #46b8b0;
    color: #fff;
  }
  .title /deep/ .el-tabs__nav-prev:hover i, .title /deep/ .el-tabs__nav-next:hover i{
    color: #fff;
  }
  .title /deep/ .el-tabs__item.is-active{
    color: #46b8b0;
    font-weight: bold;
    font-size: 16px;
  }
  .title /deep/ .el-tabs__item{
    color: #30313a;
    font-weight: bold;
    font-size: 16px;
    margin: 0 20px 0 0;
    padding: 0!important;
    display: flex;
    align-items: center;
  }
  .title /deep/ .el-tabs__item:before{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
    content: '';
    display: inline-block;
    margin-right: 5px;
  }
  .title /deep/ .el-tabs__item.is-active:before{
    background-color: #46b8b0;
  }
  .title /deep/ .el-tabs__nav-wrap.is-scrollable{
    padding:  0 40px;
  }
  .bg-82b925-20-ff{
    background: #82b925;
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
    color: #ffffff;
    font-size: 12px;
  }
  .bg-00-20-ff{
    background: rgba(0,0,0,.5);
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
    color: #ffffff;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/EnterRoom.vue